import Vue from 'vue'
import Router from 'vue-router'
import loginStore from '@/store/index.js'
import Login from '@/views/Login/Login.vue'
import SignUp from '@/views/Login/SignUp/SignUp.vue'
import Confirm from '@/views/Login/confirmUser/Confirm.vue'
import AllStations from '@/views/AllStations/AllStations.vue'
import StationsInRange from '@/views/StationsInRange/StationsInRange.vue'
import StationDetails from '@/views/StationDetails/StationDetails.vue'
import Address from '@/components/StationDetails/Address/Address.vue'
import Route from '@/components/StationDetails/Route/Route.vue'
import CreateSitePresence from '@/components/StationDetails/CreateSitePresence/CreateSitePresence.vue'
import About from '@/views/About/About.vue'
import TermsOfUse from '@/views/TermsOfUse/TermsOfUse.vue'
import Feedback from '@/views/Feedback/Feedback.vue'
import PageNotFoundComponent from '@/views/PageNotFoundComponent/PageNotFoundComponent.vue'
import Offline from '@/views/Offline/Offline.vue'
import EmailWhitelist from '@/views/Login/EmailWhitelist/EmailWhitelist.vue'
import AdminPanel from '@/views/Admin/Admin.vue'
import RemoveSitePresence from '@/components/StationDetails/RemoveSitePresence/RemoveSitePresence.vue'

Vue.use(Router)

/**
 * Defines e new Vue Router with history mode (without "#") and paths.
 * Secured views have a meta tag "requiresAuth", "requiresChange" etc. If one is present, a requests gets sent to the api
 * and checks whether the user has access.
 */
const router = new Router({
   mode: 'history',
   routes: [
      {
         path: '/',
         redirect: '/all-stations'
      },
      {
         path: '/confirm/:id',
         name: 'Confirm',
         component: Confirm,
         meta: {
            title: 'Confirm User'
         }
      },
      {
         path: '/whitelist',
         name: 'EmailWhitelist',
         component: EmailWhitelist,
         meta: {
            title: 'Email Whitelist'
         }
      },
      {
         path: '/admin',
         name: 'AdminPanel',
         component: AdminPanel,
         meta: {
            title: 'Administration'
         }
      },
      {
         path: '/all-stations',
         name: 'AllStations',
         component: AllStations,
         meta: {
            requiresAuth: true,
            title: 'All Stations'
         }
      },
      {
         path: '/stations-in-range',
         name: 'StationsInRange',
         component: StationsInRange,
         meta: {
            requiresAuth: true,
            title: 'Stations In Range'
         }
      },
      {
         path: '/station/:code',
         name: 'Station',
         redirect: '/station/:code/address',
         component: StationDetails,
         meta: {
            requiresAuth: true,
            title: 'Station'
         },
         children: [
            {
               path: 'address',
               name: 'Address',
               component: Address,
               meta: {
                  requiresAuth: true,
                  title: 'Address'
               }
            },
            {
               path: 'route',
               name: 'Route',
               component: Route,
               meta: {
                  requiresAuth: true,
                  title: 'Route'
               }
            },

            {
               path: 'create-sitepresence',
               name: 'CreateSitePresence',
               component: CreateSitePresence,
               meta: {
                  requiresAuth: true,
                  title: 'Create Sitepresence'
               }
            },

            {
               path: 'remove-sitepresence',
               name: 'RemoveSitePresence',
               component: RemoveSitePresence,
               meta: {
                  requiresAuth: true,
                  title: 'Remove Sitepresence'
               }
            }

         ]
      },
      {
         path: '/about',
         name: 'About',
         component: About,
         meta: {
            requiresAuth: true,
            title: 'About'
         }
      },
      {
         path: '/terms-of-use',
         name: 'TermsOfUse',
         component: TermsOfUse,
         meta: {
            title: 'Terms of use'
         }
      },
      {
         path: '/feedback',
         name: 'Feedback',
         component: Feedback,
         meta: {
            requiresAuth: true,
            title: 'Feedback'
         }
      },
      {
         path: '/offline',
         name: 'Offline',
         component: Offline,
         meta: {
            title: 'Offline'
         }
      },
      // HAS TO BE LAST
      {
         path: '**',
         component: PageNotFoundComponent,
         meta: {
            requiresAuth: true,
            title: 'Page Not Found'
         }
      }
   ],
   scrollBehavior() {
      document.body.scrollTop = 0 // For Safari
      document.documentElement.scrollTop = 0
   }
})

/**
 * Gets executed before each navigation.
 */
router.beforeEach((to, from, next) => {
   document.title = to.meta.title + ' - SBCGoLight'

   checkLogin(to, from, next)
   // checkIncident(to, from, next)
   // checkChange(to, from, next)
   // checkZUF(to, from, next)
})

/**
 * Checks for login requirement before routing. When the user is not logged in he gets sent to
 * the login page
 * @param {*} to Destination
 * @param {*} from Source
 * @param {*} next Next Route
 */
function checkLogin(to, from, next) {
   if (to.path !== '/login') {
       loginStore.commit('setForwardRoute', to.path)
   }
   next();
}

export default router
